import { useSelector } from 'react-redux';
import { useEffect } from 'react';

import State from '../../app/store/state';
import { TransactionDetails } from '../transactions';
import { useActionCreator } from '../../utils/useActionCreator';

export function useTransactionDetails(
    transactionId: string,
    actionCreator: (dispatch) => (transactionId: string) => void
) {
    const transactionDetails = useSelector((state: State) => state.transactionDetails) as TransactionDetails[];
    const loadTransactionDetails = useActionCreator(actionCreator, true);
    useEffect(() => {
        if (transactionId) {
            loadTransactionDetails(transactionId);
        }
    }, [transactionId]);
    return transactionDetails ? transactionDetails : [];
}
